import { router } from '@inertiajs/vue3';
import AdminInfertilityTreatmentClinicLayout from '@/Layouts/AdminInfertilityTreatmentClinic.vue';
import AdminInstituteLayout from '@/Layouts/AdminInstitute.vue';
import AdminFamilyClinicLayout from '@/Layouts/AdminFamilyClinic.vue';
import AdminCodeMedicalCenterLayout from '@/Layouts/AdminCodeMedicalCenter.vue';
import AdminLayout from '@/Layouts/Admin.vue';

// Fallback layout resolution by site_context. Used for shared/global admin
// screens whose URL is not under a per-site prefix (e.g. the shared block
// editor at /admin/blocks/:id, which follows the block's own context).
// NOTE: 'code_medical_center' intentionally maps to the global AdminLayout here
// so the global resource-page configurators (/admin/strony/...) stay in the
// global chrome. The per-site CODE admin is selected by URL prefix below.
function getLayoutBySiteContext(siteContext) {
  if (siteContext === 'infertility_treatment_clinic') {
    return AdminInfertilityTreatmentClinicLayout;
  } else if (siteContext === 'institute') {
    return AdminInstituteLayout;
  } else if (siteContext === 'family_clinic') {
    return AdminFamilyClinicLayout;
  }
  return AdminLayout;
}

function currentInertiaUrl() {
  const fromRouter = router?.page?.url;
  if (typeof fromRouter === 'string') {
    return fromRouter;
  }

  if (typeof window !== 'undefined') {
    return window.location.pathname + window.location.search;
  }

  return '';
}

// Picks the admin layout for an Inertia page. The admin URL prefix is the
// reliable signal for which site's chrome to render (site_context alone is
// ambiguous now that code_medical_center is a normal per-site admin while its
// resource pages still carry the code_medical_center context at the root).
//
// Inertia v2 calls layout functions as layout(h, pageComponentVNode) — the
// second argument is the rendered page component, not the Inertia page object.
export function createLayoutHelper(h, pageComponent) {
  const url = currentInertiaUrl();
  const siteContext = pageComponent?.props?.site_context;
  let Layout;

  if (url.startsWith('/admin/code-medical-center')) {
    Layout = AdminCodeMedicalCenterLayout;
  } else if (url.startsWith('/admin/infertility-treatment-clinic')) {
    Layout = AdminInfertilityTreatmentClinicLayout;
  } else if (url.startsWith('/admin/institute')) {
    Layout = AdminInstituteLayout;
  } else if (url.startsWith('/admin/family-clinic')) {
    Layout = AdminFamilyClinicLayout;
  } else {
    Layout = getLayoutBySiteContext(siteContext);
  }

  return h(Layout, () => [pageComponent]);
}
